import { PAGE_TYPE_ENUM } from "@shared/types";
import { DatoComponentsWrapper } from "components/common/DatoComonentsWrappeer/DatoComponentsWrapper";
import PageLayout from "components/layout/PageLayout";
import { setDYContext } from "config";
import { useLogContext } from "context/log";
import { generatePageId } from "helpers/analyticsLogger";
import { setCachingHeader } from "helpers/cacheHeader";
import { GetServerSideProps } from "next";
import { useEffect } from "react";
import { createDatoClient } from "services/datocms";
import { CollectionPageBySlugQuery, getSdk } from "services/datocms/generated";
import { createQueryParamsForCaching } from "utils/create-query-params";

interface CollectionPageProps {
  collection: CollectionPageBySlugQuery["collectionPage"] | null;
}

export const getServerSideProps: GetServerSideProps<
  CollectionPageProps
> = async (context) => {
  setCachingHeader(context);

  const slug = context?.params?.id || "";

  try {
    const { collectionPage } = await getSdk(
      createDatoClient(
        context.preview,
        createQueryParamsForCaching({
          queryType: "CollectionPageBySlug",
          queryVariables: { slug: `${slug}` },
        }),
      ),
    ).CollectionPageBySlug({ slug: `${slug}` });

    if (collectionPage) {
      return {
        props: {
          collection: collectionPage,
        },
      };
    } else {
      return {
        notFound: true,
      };
    }
  } catch (error) {
    return {
      notFound: true,
    };
  }
};

const CollectionPage = ({ collection }: CollectionPageProps) => {
  const { useLogPageView } = useLogContext();

  useLogPageView({
    pageType: PAGE_TYPE_ENUM.collection,
    id: generatePageId(collection?.slug || ""),
  });

  useEffect(() => {
    if (collection?.title) {
      setDYContext("OTHER", [collection?.title || ""]);
    }
  }, [collection?.title]);

  return (
    <PageLayout seo={collection?.seo}>
      <div className="container flex flex-col py-6">
        {collection && (
          <DatoComponentsWrapper
            components={collection.components}
            analyticsName={collection.title || ""}
          />
        )}
      </div>
    </PageLayout>
  );
};

export default CollectionPage;
